import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AddDocFinalization, EditDocFinalization } from './doc-finalization.interface';
import { catchError, map, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class DocFinalizationService {
    private token!: string;
    private basePath = environment.interop.basePath;

    private listUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.finalizareTypes.list;

    public listDTUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.finalizareTypes.listDT;

    private findURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.finalizareTypes.find;

    private storeURL =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.finalizareTypes.store;

    private updateUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.finalizareTypes.update;

    private deleteUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.finalizareTypes.delete;

    private listActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.finalizareTypes
            .listActive;

    private listPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.finalizareTypes
            .listPublic;

    private changeStatusActiveUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.finalizareTypes
            .active;

    private changeStatusPublicUrl =
        this.basePath +
        environment.interop.indoc.nomenclatoare.registratura.finalizareTypes
            .public;

    private httpOptions: any;

    constructor(private http: HttpClient) { }

    getList() {
        return this.http
            .get<{ errors: boolean; data: any[]; status_code: number }>(
                this.listUrl
            )
            .pipe(
                map((response) =>
                    response.data.map((item) => ({
                        id: item.id,
                        name: item.name,
                    }))
                ),
                catchError((error) => {
                    console.error('Error in get finalizare types:', error);
                    return throwError(error);
                })
            );
    }

    getListDT() {
        return this.http.get(this.listDTUrl, this.httpOptions);
    }

    findEntry(id: number) {
        return this.http.post(this.findURL + id, this.httpOptions);
    }

    storeEntry(payload: AddDocFinalization) {
        return this.http.post(this.storeURL, payload, this.httpOptions);
    }

    updateEntry(payload: EditDocFinalization) {
        return this.http.put(this.updateUrl, payload, this.httpOptions);
    }

    deleteEntry(id: number) {
        return this.http.delete(this.deleteUrl + id, this.httpOptions);
    }

    getListActive() {
        return this.http.get(this.listActiveUrl, this.httpOptions);
    }

    getListPublic() {
        return this.http.get(this.listPublicUrl, this.httpOptions);
    }

    changeStatusActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusPublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
